/**
* @module @pakal/curry
* @copyright © 2018 Yisrael Eliav <yisraelx@gmail.com> (https://github.com/yisraelx)
* @license MIT
*/
import arity from '@pakal/arity';

var __ = { '@@functional/placeholder': true };
function isPlaceholder(arg) {
    return typeof arg === 'object' && arg['@@functional/placeholder'] === true;
}
function curry(fn, length) {
    if (length === void 0) { length = fn.length; }
    var next = function (previousArgs, count) {
        var nextLength = length - count;
        return arity(function () {
            var currentLength = arguments.length < length ? arguments.length : length;
            var currentArgs = [].concat(previousArgs);
            var currentCount = count;
            var pos = 0;
            for (var i = 0; i < currentLength; i++) {
                var arg = arguments[i];
                while (pos < length && !isPlaceholder(currentArgs[pos])) {
                    pos++;
                }
                if (!isPlaceholder(arg)) {
                    currentCount++;
                    currentArgs[pos] = arg;
                }
                pos++;
            }
            return currentCount >= length ? fn.apply(this, currentArgs) : next(currentArgs, currentCount);
        }, nextLength);
    };
    var args = Array.apply(null, Array(length)).map(function () { return __; });
    return next(args, 0);
}

export default curry;
export { __ };
//# sourceMappingURL=index.esm.js.map
